/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import QS from 'qs';

// 环境切换
//'https://sapi.52santao.com/agency'; 线上
//https://sapi.52santao.com/csa;测试
if (process.env.NODE_ENV == 'development') {
    // axios.defaults.baseURL =  'http://47.101.50.162:3050';
    axios.defaults.baseURL =  'https://sapi.52santao.com/agency';
} else if (process.env.NODE_ENV == 'test') {
    axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL =  'https://sapi.52santao.com/agency';
}

import Vue from 'vue'
Vue.prototype.imgUrl = axios.defaults.baseURL

// 请求超时时间
axios.defaults.timeout = 10000;
axios.defaults.withCredentials = false;
// 请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 请求拦截
axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截
axios.interceptors.response.use(
    response => {
        if (response.data.code !== "000000") {
            alert(res.data.msg || res.data.message)
        }
        return Promise.resolve(response);
    },
    // 服务器状态码不是200的情况
    error => {
        alert("网络错误，请联系管理员")
        return Promise.reject(error)
    }
)
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params})
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params))
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/**
 * postFile方法，上传文件或者图片
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
*/
export function postImg(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err.data)
            })
    });
}



// WEBPACK FOOTER //
// ./src/request/http.js